export const PERMISSION_KEYS = [
    "canManageUsers",
    "canManageCompanies",
    "canManageLicenses",
    "canManageRoomTypes",
    "canManageApps",
    "canManageRadioStations",
    "canManageSchemeDefaults",
    "canManageSettings",
    "canManageMedia",
    "canManageDistribution",
    "canTrustSuppliers",
    "canViewFleet",
    "canManageOta",
    "canEditPremise",
    "canEditLayout",
    "canManageRooms",
    "canManageDevices",
    "canPairTVs",
    "canSendMessages",
    "canManageHospitality",
    "canToggleOccupancy",
    "canManageCareProfiles",
    "canHandleServiceRequests",
    "canViewPhi",
    "canManageCallContacts",
    "canManageSignage",
    "canAuthorSignageTemplates",
    "canEditSignageContent",
    "canManageOffers",
    "canHandleGuestRequests",
    "canUploadOwnContent",
    "canViewOwnContentReach",
    "canManageOwnTeam",
];
export const PERMISSION_CATALOGUE = [
    {
        key: "canManageUsers",
        label: "Manage users & invites",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageCompanies",
        label: "Manage companies",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageLicenses",
        label: "Manage licenses",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageRoomTypes",
        label: "Manage global room types",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageApps",
        label: "Manage the global app catalogue",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageRadioStations",
        label: "Manage the global radio catalogue",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageSchemeDefaults",
        label: "Manage global scheme defaults",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageSettings",
        label: "Edit global platform settings",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageMedia",
        label: "Manage the global media library",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canManageDistribution",
        label: "Manage the distribution catalogue (channels & VOD)",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canTrustSuppliers",
        label: "Trust content suppliers (auto-publish their new titles)",
        group: "Global",
        adminOnly: true,
    },
    {
        key: "canViewFleet",
        label: "View device fleet (all premises)",
        group: "Global",
    },
    {
        key: "canManageOta",
        label: "Manage OTA rollouts",
        group: "Global",
    },
    { key: "canEditPremise", label: "Edit premise details", group: "Premise" },
    { key: "canEditLayout", label: "Edit layout & templates", group: "Premise" },
    { key: "canManageRooms", label: "Manage rooms", group: "Premise" },
    { key: "canManageDevices", label: "Manage devices", group: "Premise" },
    { key: "canPairTVs", label: "Pair new TVs", group: "Premise" },
    { key: "canSendMessages", label: "Send messages to TVs", group: "Premise" },
    {
        key: "canManageHospitality",
        label: "Edit PMS configuration",
        group: "Hospitality",
    },
    {
        key: "canToggleOccupancy",
        label: "Check rooms in / out",
        group: "Hospitality",
    },
    {
        key: "canManageCareProfiles",
        label: "Manage care profiles (admit / discharge residents)",
        group: "Care",
    },
    {
        key: "canHandleServiceRequests",
        label: "Handle care service requests",
        group: "Care",
    },
    {
        key: "canViewPhi",
        label: "View protected health information (PHI)",
        group: "Care",
    },
    {
        key: "canManageCallContacts",
        label: "Manage who may video-call a resident's room",
        group: "Care",
    },
    {
        key: "canManageSignage",
        label: "Author signage content & schedules",
        group: "Premise",
    },
    {
        key: "canAuthorSignageTemplates",
        label: "Design signage templates",
        group: "Premise",
    },
    {
        key: "canEditSignageContent",
        label: "Update unlocked information on signage screens",
        group: "Premise",
    },
    {
        key: "canManageOffers",
        label: "Author offers, for one hotel or a whole chain",
        group: "Hospitality",
    },
    {
        key: "canHandleGuestRequests",
        label: "Handle guest orders & bookings",
        group: "Hospitality",
    },
    {
        key: "canUploadOwnContent",
        label: "Upload and edit their own titles",
        group: "Content owner",
        ownerOnly: true,
    },
    {
        key: "canViewOwnContentReach",
        label: "See their own reach, rentals and plays",
        group: "Content owner",
        ownerOnly: true,
    },
    {
        key: "canManageOwnTeam",
        label: "Invite and remove colleagues in their own organisation",
        group: "Content owner",
        ownerOnly: true,
    },
];
export const ADMIN_ONLY_PERMISSIONS = new Set(PERMISSION_CATALOGUE.filter((p) => p.adminOnly).map((p) => p.key));
export function isTenantScoped(user) {
    var _a;
    return (!!user.company ||
        ((_a = user.premises) !== null && _a !== void 0 ? _a : []).length > 0 ||
        (typeof user.contentOwner === "string" && user.contentOwner.trim() !== ""));
}
export const OWNER_ONLY_PERMISSIONS = new Set(PERMISSION_CATALOGUE.filter((p) => p.ownerOnly).map((p) => p.key));
export const SIMPLE_ROLES = [
    {
        key: "admin",
        label: "Nenda admin",
        description: "Nenda staff. Reaches every customer; belongs to no company.",
        storedRole: "admin",
    },
    {
        key: "editor",
        label: "Company admin",
        description: "The customer's administrator. Manages their own premises.",
        storedRole: "companyAdmin",
    },
    {
        key: "viewer",
        label: "Viewer",
        description: "Read-only access.",
        storedRole: "companyUser",
    },
    {
        key: "contentOwner",
        label: "Content owner",
        description: "External supplier. Sees only their own titles, never the catalogue.",
        storedRole: "contentOwner",
    },
];
export const DEFAULT_PERMISSIONS_FOR_ROLE = {
    admin: PERMISSION_KEYS.filter((k) => !OWNER_ONLY_PERMISSIONS.has(k)),
    editor: [
        "canViewFleet",
        "canManageOta",
        "canEditPremise",
        "canEditLayout",
        "canManageRooms",
        "canManageDevices",
        "canPairTVs",
        "canSendMessages",
        "canManageHospitality",
        "canToggleOccupancy",
        "canHandleGuestRequests",
        "canManageCareProfiles",
        "canHandleServiceRequests",
        "canManageCallContacts",
        "canAuthorSignageTemplates",
    ],
    viewer: [],
    contentOwner: ["canUploadOwnContent", "canViewOwnContentReach"],
};
export function storedRoleToSimple(role) {
    if (role === "admin")
        return "admin";
    if (role === "contentOwner")
        return "contentOwner";
    if (role === "companyUser" ||
        role === "premiseUser" ||
        role === "premiseGroupUser" ||
        role === "basic") {
        return "viewer";
    }
    return "editor";
}
